import { LegalPage } from "./legal-page.tsx";

export function PrivacyPage() {
  return <LegalPage slug="privacy" />;
}
